import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Col, Row } from 'react-bootstrap'
import PropTypes from 'prop-types'

import { backorderNonVerifiedParcels } from '../../../utils/terminal-sorting-webapi'

class BackorderButton extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isBackordering: false,
            numberOfBackorderedParcels: 0,
        }
    }

    backorder = () => {
        const { selectedTerminalId, nonVerifiedParcels } = this.props
        let message = 'Has every Route been sorted for Distribution?'
        message += ` ${nonVerifiedParcels.length} parcels will be backordered`
        if (window.confirm(message)) {
            this.setState({ isBackordering: true })
            backorderNonVerifiedParcels(selectedTerminalId).then((resp) => {
                this.setState({ isBackordering: false, numberOfBackorderedParcels: resp.length })
            })
        }
    }

    renderBackorderButton() {
        const { isBackordering } = this.state
        const { nonVerifiedParcels } = this.props
        return (
            <Button
                bsStyle="danger"
                block
                disabled={nonVerifiedParcels.length === 0 || isBackordering}
                onClick={this.backorder}
            >
                <p>Backorder missing Parcels</p>
                <small>Estimation: {nonVerifiedParcels.length} Parcels</small>
            </Button>
        )
    }

    render() {
        const { numberOfBackorderedParcels } = this.state
        return (
            <Row>
                <Col xs={6}>
                    <div className="alert alert-route" role="alert">
                        {numberOfBackorderedParcels > 0 && (
                            <span>Successfully Backordered {numberOfBackorderedParcels} Parcels</span>
                        )}
                        {this.renderBackorderButton()}
                    </div>
                </Col>
            </Row>
        )
    }
}

BackorderButton.propTypes = {
    selectedTerminalId: PropTypes.number.isRequired,
    nonVerifiedParcels: PropTypes.array,
}

const mapStateToProps = (state) => ({
    nonVerifiedParcels: state.backorderMissingParcels.nonVerifiedParcels,
})

export default connect(mapStateToProps)(BackorderButton)
